import React from "react";

import {Chronos} from "../entity/Chronos";

export const CommonUtil = {
    getOrDefault : (obj, keyName, defaultValue, allowNulls) => {
        if (allowNulls === undefined) {
            allowNulls = false;
        }

        if (obj !== undefined && obj !== null && typeof obj === 'object') {
            if (obj.hasOwnProperty(keyName)) {
                if ((!allowNulls && obj[keyName] != null) || allowNulls) {
                    return obj[keyName];
                }
            }
        }
        return defaultValue;
    },
    safeCallback : (callback, action, data) => {
        if (callback) {
            callback(action, data);
        }
    },
    cloneObject : (object) => {
        return Object.assign({}, object)
    },
    isObject : (object) => {
        return typeof(object) === "object";
    },
    mergeObjects : (o1, o2) => {
        let newFormData = CommonUtil.cloneObject(o1);

        Object.keys(o2).forEach((key) => {
            if (key !== "step") {
                newFormData[key] = o2[key];
            }
        });

        return newFormData;
    },
    getGoogleMapsLink : (addressParts) => {
        let searchQuery = "";
        if (Array.isArray(addressParts)) {
            addressParts.forEach((part) => {
                if (part !== undefined) {
                    if (searchQuery !== "") {
                        searchQuery += "+";
                    }
                    searchQuery += encodeURIComponent(part.toLowerCase().replaceAll(" ", "+"));
                }
            });
        } else {
            searchQuery = encodeURIComponent(addressParts.replaceAll(" ", "+"));
        }

        return "https://www.google.com/maps/search/" + searchQuery + "/";
    },
    implode : (data, delimiter) => {
        if (delimiter === undefined) {
            delimiter = ", ";
        }

        let out = "";

        for (let i = 0; i < data.length; i++) {
            if (data[i] !== null && data[i] !== "") {
                if (out !== "") {
                    out += delimiter;
                }
                out += data[i];
            }
        }

        return out;
    },
    generateFilterSelect : (label, options, value, callback, idKey, labelKey, defaultId, defaultLabel) => {
        if (idKey === undefined) {
            idKey = "id";
        }

        if (labelKey === undefined) {
            labelKey = "name";
        }

        if (defaultLabel === undefined) {
            defaultLabel = "Any";
        }

        if (defaultId === undefined) {
            defaultId = "-1";
        }

        return (
            <>
                <label>{label}</label>
                <select className={"form-select"} value={value} onChange={callback}>
                    <option value={defaultId}>{defaultLabel}</option>
                    {
                        options.map((option) => (
                            <option value={option[idKey]}>{option[labelKey]}</option>
                        ))
                    }
                </select>
            </>
        )
    },
    generateFilterPayload : (properties) => {
        let tablePayload = {};

        for (const prop of properties) {
            let allowMinusOne = false;
            if (prop.hasOwnProperty("allowMinusOne")) {
                allowMinusOne = prop.allowMinusOne;
            }

            if (prop.value && prop.value !== "" && (allowMinusOne || prop.value !== "-1")) {
                if (prop.hasOwnProperty("isArray") && prop.isArray) {
                    tablePayload[prop.key] = JSON.stringify([prop.value]);
                } else if (prop.hasOwnProperty("isDate") && prop.isDate) {
                    tablePayload[prop.key] = Chronos.with(new Date(prop.value)).seconds();
                } else {
                    tablePayload[prop.key] = prop.value;
                }
            }
        }

        return tablePayload;
    },
    objectToFormData : (object, ignoreKeys) => {
        let out = new FormData();

        let keys = Object.keys(object);

        keys.forEach((key) => {
            let shouldIgnore = false;
            if (ignoreKeys && Array.isArray(ignoreKeys)) {
                for (let i = 0; i < ignoreKeys.length; i++) {
                    if (ignoreKeys[i] === key) {
                        shouldIgnore = true;
                        break;
                    }
                }
            }

            if (!shouldIgnore) {
                if (object[key] !== null && object[key] !== undefined) {
                    let value = object[key];
                    if (Array.isArray(value) || CommonUtil.isObject(value)) {
                        value = JSON.stringify(value);
                    }

                    out.append(key, value);
                }
            }
        });

        return out;
    },
    parseBool : (input) => {
        if (input === true || input === false) {
            return input;
        }

        if (input.hasOwnProperty("toLowerCase")) {
            let inputS = input.toLowerCase();
            if (inputS === "true") {
                return true;
            } else if (inputS === "false") {
                return false;
            }
        }

        let inputN = parseInt(input);
        if (!isNaN(inputN)) {
            if (inputN === 1) {
                return true;
            } else if (inputN === 0) {
                return false;
            }
        }

        return undefined;
    },
    printObject : (obj) => {
        let out = "";

        let keys = Object.keys(obj);
        keys.forEach((key) => {
            if (out !== "") out += ", ";
            out += key + " = " + obj[key];
        });

        return out;
    }
}